var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stat-card',{attrs:{"label":"Lieu","loading":_vm.loading,"stat":!_vm.loading ? _vm.session.place.name : '',"color-class":"bg-green-500"}},[_c('HomeIcon',{staticClass:"w-6 h-6 text-white"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }